
import React from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Edit, Loader2 } from 'lucide-react'; // Added Loader2
import { useBusinessOnboarding } from '@/hooks/useBusinessOnboarding';
// import { useData } from '@/context/DataContext'; // Removed
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { doc } from 'firebase/firestore'; // Added
import { useDocumentData } from 'react-firebase-hooks/firestore'; // Added
import { db } from '@/utils/firebase'; // Added

interface SelectedGoPlanCardProps {
  onEditClick?: (e?: React.MouseEvent) => void;
  className?: string;
}

const SelectedGoPlanCard: React.FC<SelectedGoPlanCardProps> = ({ 
  onEditClick,
  className = ""
}) => {
  const { businessId, navigateToStep } = useBusinessOnboarding();
  
  const businessDocRef = businessId ? doc(db, 'businesses', businessId) : null;
  const [businessData, isLoadingBusiness, errorBusiness] = useDocumentData(businessDocRef);
  
  const selectedPackage = businessData?.package || null;
  
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    console.log('SelectedGoPlanCard clicked, navigating to step 0');
    
    if (onEditClick) {
      onEditClick(e);
    } else {
      navigateToStep(0);
    }
  };
  
  if (isLoadingBusiness) {
    return (
      <div className={cn("flex items-center justify-center p-2", className)}>
        <Loader2 size={16} className="animate-spin text-muted-foreground" />
        <span className="ml-2 text-xs text-muted-foreground">Loading plan...</span>
      </div>
    );
  }

  if (errorBusiness) {
    console.error("Error fetching business package:", errorBusiness);
    return (
      <div className={cn("p-2 text-xs text-red-500", className)}>
        Error loading plan.
      </div>
    );
  }

  return (
    <Button
      variant="ghost"
      className="p-0 h-auto w-auto hover:bg-accent/30 transition-colors cursor-pointer group"
      onClick={handleClick}
      disabled={!businessId} // Disable if no businessId
    >
      <Card className={cn("bg-white border border-gray-200 flex flex-col", className)}>
        <CardHeader className="pb-1 pt-2 px-0 text-left">
          <div className="flex items-center">
            <h3 className="text-xs font-medium text-muted-foreground">Selected GoPlan</h3>
            {selectedPackage && (
              <Edit 
                size={12} 
                className="text-muted-foreground ml-1" 
              />
            )}
          </div>
        </CardHeader>
        <CardContent className="px-0 pb-2 pt-0 text-left">
          <div className="flex flex-col items-start">
            <p className="font-semibold text-sm leading-tight">
              {selectedPackage === 'essentials' && 'Essentials'}
              {selectedPackage === 'premium' && 'Premium'}
              {selectedPackage === 'elite' && 'Elite'}
              {selectedPackage === 'freemium' && 'Google Business Profile Optimization'}
              {selectedPackage === 'landing-pages' && 'Instant Business Website'}
              {selectedPackage === 'google-ads' && 'Google Ads Automation + Website'}
              {(!selectedPackage && businessId) && 'Select a plan'}
              {!businessId && 'No Business Selected'}
            </p>
          </div>
        </CardContent>
      </Card>
    </Button>
  );
};

export default SelectedGoPlanCard;
